import { SharedChannelBadge } from '@features/components/Chat/components/SharedChannelBadge';
import { IoVolumeMuteOutline } from 'react-icons/io5';
import { MdPushPin } from 'react-icons/md';
import { StreamChannelType } from '@/api/apis/chat';

export const ChannelStateIndicators = ({
  isPinned,
  isMuted,
  channelType,
}: {
  isPinned: boolean;
  isMuted: boolean;
  channelType: StreamChannelType;
}) => {
  return (
    <span className="flex gap-1 items-center text-base-40 shrink-0">
      <SharedChannelBadge channelType={channelType} />
      {isPinned && <MdPushPin size={14} className="rotate-45 text-red" />}
      {isMuted && <IoVolumeMuteOutline size={14} className="text-base-20" />}
    </span>
  );
};
